import * as tslib_1 from "tslib";
import { getOptionsForFeature, lazyCreateOrUpdateOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import updateUserConfettiOption from '../data/mutators/updateUserConfettiOption';
import isConfettiEnabled from '../selectors/isConfettiEnabled';
import datapoints from 'owa-confetti-v2/lib/utils/datapoints';
import { logUsage } from 'owa-analytics';
export default function saveConfettiOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var userOptions, confettiEnabled, eventName;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userOptions = getOptionsForFeature(OwsOptionsFeatureType.Confetti);
                    confettiEnabled = isConfettiEnabled();
                    updateUserConfettiOption(userOptions, confettiEnabled);
                    return [4 /*yield*/, lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.Confetti, userOptions)];
                case 1:
                    _a.sent();
                    if (!confettiEnabled) {
                        eventName = datapoints.ConfettiSettingDisabled.datapoint.name;
                        logUsage(eventName);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=saveConfettiOption.js.map